// extracted by mini-css-extract-plugin
export default {"root":"search_root__KI8bc","search":"search_search__O9jq5","close":"search_close__aOqih"};